import { selectRequestByType } from 'ducks/requests/selectors'
import { buildFetchFolderCountsRequestKey } from 'ducks/searches/utils/request'

export const selectSearchesRequestState = state =>
  selectRequestByType(state, buildFetchFolderCountsRequestKey(null))
